import { DocumentListItem } from 'src/models/documentList';
import { ActivityListTypeEnum } from 'src/models/genericActivityList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { DocumentListCallbackStoreContract } from '../interfaces';

export class GetTheMineDocumentModuleDocumentsForTheUserCallBack extends Callback<DocumentListItem[]> {
	public constructor(
		private readonly store: DocumentListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: DocumentListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.MINE, this.queryIdentifier)) {
			return;
		}

		this.store.setMineDocumentList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
